'use client';
import React, { useState } from 'react';
import { Toaster } from 'sonner';
import PriceTableSettings from './PriceTableSettings';
import MessageTemplateSettings from './MessageTemplateSettings';
import SubscriptionSettings from './SubscriptionSettings';
import { DollarSign, MessageSquare, CreditCard } from 'lucide-react';

type SettingsTab = 'price-table' | 'templates' | 'subscription';

const tabs: { id: SettingsTab; label: string; icon: React.ReactNode }[] = [
  { id: 'price-table', label: 'Price Table', icon: <DollarSign size={16} /> },
  { id: 'templates', label: 'Message Templates', icon: <MessageSquare size={16} /> },
  { id: 'subscription', label: 'Subscription', icon: <CreditCard size={16} /> },
];

export default function BusinessSettingsContent() {
  const [activeTab, setActiveTab] = useState<SettingsTab>('price-table');

  return (
    <>
      <Toaster position="bottom-right" theme="dark" />
      {/* Page header */}
      <div className="mb-6">
        <h1 className="text-2xl font-800 text-white">Business Settings</h1>
        <p className="text-[#666] text-sm mt-0.5">Configure your pricing rules, response templates, and subscription</p>
      </div>

      {/* Tabs */}
      <div className="flex items-center gap-0 border-b border-[#1F1F1F] mb-6 overflow-x-auto scrollbar-thin">
        {tabs.map((tab) => (
          <button
            key={`settings-tab-${tab.id}`}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-600 whitespace-nowrap transition-all duration-150 border-b-2 -mb-px
              ${activeTab === tab.id
                ? 'text-white border-blue-500' :'text-[#666] border-transparent hover:text-[#999]'
              }
            `}
          >
            <span className={activeTab === tab.id ? 'text-blue-400' : 'text-[#555]'}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="animate-fade-in">
        {activeTab === 'price-table' && <PriceTableSettings />}
        {activeTab === 'templates' && <MessageTemplateSettings />}
        {activeTab === 'subscription' && <SubscriptionSettings />}
      </div>
    </>
  );
}